import {NgModule} from '@angular/core';
import {MaterialModule} from '../material/material.module';
import {AirportsComponent} from './components/airports/airports.component';
import {ArchivedAirportsComponent} from './components/archived-airports/archived-airports.component';
import {AirportService} from './services/airport/airport.service';
import {ArchivedAirportsService} from './services/archived-airports/archived-airports.service';
import {UtilitiesModule} from '../utilities/utilities.module';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { AirportEditComponent } from './components/airport-edit/airport-edit.component';
import {ReportModule} from '../report/report.module';
import {AirportResolverService} from './resolvers/airport-resolver.service';

@NgModule({
  declarations: [
    AirportsComponent,
    ArchivedAirportsComponent,
    AirportEditComponent
  ],
  imports: [
    MaterialModule,
    UtilitiesModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ReportModule
  ],
  exports: [
    AirportsComponent,
    ArchivedAirportsComponent
  ],
  providers: [
    AirportService,
    ArchivedAirportsService,
    AirportResolverService
  ]
})
export class AirportModule { }



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/airport/airport.module.ts